import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { ProductWizardType, WizardData } from '../../types'

const SmallText = styled.p`
  margin: 0;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: ${({ theme }) => theme.color.secondary300};
`

export type ProcoteWizardDataProps = { data: WizardData<ProductWizardType.Procote> }

export const ProcoteWizardData: FC<ProcoteWizardDataProps> = ({ data: { sku_params } }) => {
  const { t } = useTranslation('procote')

  if (!sku_params) return null

  const { expected_yield_unit, litres_per_tonne, category_name, expected_yield, fertilizer, acres } = sku_params

  return (
    <div>
      {!!litres_per_tonne && (
        <SmallText>{`${parseFloat(litres_per_tonne.toString())} ${t('measures.short.lTonne')}`}</SmallText>
      )}
      {!!category_name && <SmallText>{`${t('stepResult.tableHeader.crops')}: ${category_name}`}</SmallText>}
      {!!expected_yield && (
        <SmallText>{`${t('stepResult.tableHeader.expectedYield')}: ${expected_yield} ${expected_yield_unit ||
          ''}`}</SmallText>
      )}
      {!!fertilizer && <SmallText>{`${t('stepResult.tableHeader.dryFertilizer')}: ${fertilizer}`}</SmallText>}
      {!!acres && <SmallText>{`${t('stepResult.tableHeader.totalTreated')}: ${acres}`}</SmallText>}
    </div>
  )
}
